import { useState } from "react";
import AllUserTable from "../forms/admin/Cod_allUsertable";
import config from '../../config/config';
import { userSession } from "../../observers/userObserver";

// import { userSession } from "../observers/userObserver";

const AllUserAdministrationComponent = () => {

    
      
    return (
        <>
            <div className="dashboard-header">
                <h4 className="welcomeText">All Users</h4>
            </div>
            <AllUserTable />
        </>
    );
}

export default AllUserAdministrationComponent;